import React, { useEffect, useState } from "react";
import StatsCards from "./Components/StatsCards";
import VehicleTypeChart from "./Components/VehicleTypeChart";
import VehicleStatusChart from "./Components/VehicleStatusChart";
import ParkingStatsChart from "./Components/ParkingStatsChart";
import SiteStatsChart from "./Components/SiteStatsChart";
import ParkingCollectionChart from "./Components/ParkingCollectionChart";
import RevenueComparisonChart from "./Components/RevenueComparisonChart";
import { InputText } from "primereact/inputtext";
import classNames from "classnames";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import moment from "moment";
import appUrl from "../../../config/appUrl";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import Details from "./Components/MerchantDashboardComponent/details";
import Overview from "./Components/MerchantDashboardComponent/overview";
import { toast } from "react-toastify";
import axios from "axios";
import transactions from "../../../../assets/transactions.png";
import performance from "../../../../assets/performance.png";

const Dashboardd = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [dashList, setDashList] = useState([]);
  const [totalFee, setTotalFee] = useState("");
  const [siteId, setSiteId] = useState("");
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [boothList, setBoothList] = useState("");
  const [selectedVehicleType, setSelectedVehicleType] = useState(null);
  const [booothId, setBooothId] = useState("");
  const [siteList, setSiteList] = useState([]);
  const [siteValue, setSitevalue] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState(0);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState(null);
  const [stateRevenue, setStateRevenue] = useState([]);
  const [initialized, setInitialized] = useState(false);
  const [statsData, setStatsData] = useState({
    totalEnter: 0,
    totalParked: 0,
    totalExit: 0,
    totalFee: 0,
  });
  const [revenue, setRevenue] = useState({
    totalCarRevenue: 0,
    totalBikeRevenue: 0,
  });
  console.log("revenue", revenue);
  const date = new Date();
  let currentDate = moment(date).format("YYYY-MM-DD");
  const [fromDate, setFromDate] = useState(currentDate);
  const [toDate, setToDate] = useState(currentDate);
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setGlobalFilterValue(value);
    getSateRevenueData(1, currentPageSize, value); // searchText passed here
    setCurrentPage(1);
  };

  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  console.log("storedLoginRes: ", storedLoginRes);
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site?._id;
  useEffect(() => {
    formik.setFieldValue("site", userSite);
    setSitevalue(userSite);
    setSiteId(userSite);
    setInitialized(true);
  }, []);
  useEffect(() => {
    const foundSite = siteList?.find((item) => item?._id === userSite);
    setSitevalue(foundSite);
  }, [userSite, siteList]);
  const validationSchema = Yup.object().shape({
    // name: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      boothId: "",
      fromDate: "",
      toDate: "",
      site: "",
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const getSateRevenueData = async () => {
    try {
      setStatsData([]); // Clear old data

      // Get payment flags
      const paymentFlags = getPaymentFlags(); // { gtagOnly: true/false, qrOnly: true/false }

      // Build URL with payment flags
      const queryParams = new URLSearchParams({
        site: formik.values.site || "",
        fromDate,
        toDate,
        gtagOnly: paymentFlags.gtagOnly,
        qrOnly: paymentFlags.qrOnly,
      });

      const response = await fetch(
        `${appUrl.BASE_URL}ParkingHistory/getDashboardData1?${queryParams.toString()}`,
      );

      const data = await response.json();
      setStatsData(data?.data || []);

      console.log("Data received from API:", data);
    } catch (error) {
      console.error(error);
      setStatsData([]); // Clear old data on error
    }
  };

  const handleDateChange = (e) => {
    setFromDate(e.target.value);
    setInitialized(true);
  };
  useEffect(() => {
    getSateRevenueData();
  }, []);

  const getRevenueData = async () => {
    try {
      setRevenue({ totalCarRevenue: 0, totalBikeRevenue: 0 }); // reset

      let apiUrl = `${appUrl.BASE_URL}parkingHistory/revenueReportVehicleBased?fromDate=${fromDate}&toDate=${toDate}`;

      if (formik.values.site) {
        apiUrl += `&site=${formik.values.site}`;
      }

      const response = await fetch(apiUrl);
      const data = await response.json();

      if (
        data?.totalCarRevenue !== undefined &&
        data?.totalBikeRevenue !== undefined
      ) {
        setRevenue(data);
      } else {
        setRevenue({ totalCarRevenue: 0, totalBikeRevenue: 0 });
      }

      console.log("Revenue Data:", data);
    } catch (error) {
      console.error(error);
      setRevenue({ totalCarRevenue: 0, totalBikeRevenue: 0 });
    }
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getRevenueData();
    }
  }, [formik.values.site, fromDate, toDate]);

  const getBoothId = async () => {
    try {
      let apiUrl = `${appUrl.BASE_URL}booth/getBySite`;
      if (siteId) {
        apiUrl += `?siteId=${siteId}`;
      }
      const response = await fetch(apiUrl);
      const data = await response.json();
      setBoothList(data?.data);
      console.log("data", data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSiteList(data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (formik.values.site !== null && formik.values.site !== "") {
      getBoothId();
    }
    getSiteList();
  }, [formik.values.site]);
  const getVehicleTypeList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}category`);
      const data = await response.json();
      setVehicleTypeList(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVehicleTypeList();
  }, []);
  const paymentOptions = [
    { label: "All", value: "All" },
    { label: "Non-Cash Only", value: "Non-Cash Only" },
    { label: "GTag Only", value: "GTag Only" },
    { label: "QR Only", value: "QR Only" },
  ];

  // helper function jo dropdown value ko boolean flags me convert kare
  const getPaymentFlags = () => {
    switch (selectedPaymentType) {
      case "GTag Only":
        return { gtagOnly: true, qrOnly: false };
      case "QR Only":
        return { gtagOnly: false, qrOnly: true };
      case "Non-Cash Only":
        return { gtagOnly: true, qrOnly: true };
      default: // Cash Only ya kuch bhi na select
        return { gtagOnly: false, qrOnly: false };
    }
  };

  // MERCHANT DASHBOARD LOGIC STARTS HERE

  const [activeView, setActiveView] = useState(() => {
    return localStorage.getItem("dashboardView") || "details";
  });
  const [overviewData, setOverviewData] = useState(null);
  const [detailsData, setDetailsData] = useState(null);

  const [overviewLoading, setOveriewLoading] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);

  useEffect(() => {
    localStorage.setItem("dashboardView", activeView);
  }, [activeView]);

  const getDashboardOverview = async (isInitialLoad = false) => {
    setOveriewLoading(true);
    try {
      const response = await axios.post(
        `https://merchant-notifier.appinsnap.com/api/DashboardCEO/overview/`,
      );
      setOverviewData(response.data);

      if (isInitialLoad) {
        const defaultMerchant = response.data?.overviewStats?.find(
          (m) => m.isDefault,
        );
        if (defaultMerchant) {
          getDashboardDetails(
            defaultMerchant.userId,
            defaultMerchant.roleId,
            defaultMerchant.merchantUserId,
          );
        }
      }
    } catch (error) {
      toast.error("Error loading overview.");
    } finally {
      setOveriewLoading(false);
    }
  };

  useEffect(() => {
    getDashboardOverview(true);
  }, []);

  const getDashboardDetails = async (uId, rId, mUId) => {
    setDetailsLoading(true);
    try {
      const requestBody = { userId: uId, roleId: rId, merchantUserId: mUId };
      const response = await axios.post(
        `https://merchant-notifier.appinsnap.com/api/DashboardCEO/details`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setDetailsData(response.data);
    } catch (error) {
      toast.error("Failed to fetch dashboard details.");
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleSetDefault = async (merchant) => {
    setOveriewLoading(true);
    try {
      const payload = { userId: merchant.userId };
      await axios.post(
        `https://merchant-notifier.appinsnap.com/api/DashboardCEO/set-is-default/${merchant.userId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      toast.success(`${merchant.name} set as default`);

      // This is your intentional call to get the data for the new default
      await getDashboardDetails(
        merchant.userId,
        merchant.roleId,
        merchant.merchantUserId,
      );

      setActiveView("details");

      // This call will now just refresh the list without triggering a second details call
      getDashboardOverview(false);
    } catch (error) {
      console.error("Set Default Error:", error);
      toast.error("Failed to set default merchant.");
    } finally {
      setOveriewLoading(false);
    }
  };

  return (
    <div className="dashboard-page">
      <div className="p-fluid grid">
        <div className="col-12">
          <div className="dashboard-toolbar">
            <InputText
              className="mbl_view w-full md:w-auto"
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Searc"
            />
            <Button
              label="Filters"
              icon="pi pi-filter"
              className= "custome-btn"
              onClick={() => setShowFilters((prevState) => !prevState)}
            />
          </div>
        </div>

        {showFilters && (
          <div className="col-12 dashboard-filters-drawer flex flex-row flex-wrap gap-3 align-items-end">
            {/* Site Dropdown */}
            <div className="flex-1 min-w-[200px]">
              <Dropdown
                id="site"
                name="site"
                value={formik.values.site}
                onChange={(e) => {
                  formik.handleChange(e);
                  setSiteId(e.target.value);
                }}
                filter
                filterBy="site"
                filterMatchMode="contains"
                className={classNames(
                  { "p-invalid": isFormFieldValid("site") },
                  "w-full TextArea__Round border-round-3xl",
                )}
                options={siteList}
                optionLabel="site"
                optionValue="_id"
                placeholder="Select Site"
                disabled={!!siteValue && siteValue._id === formik.values.site}
                showClear
              />
              {getFormErrorMessage("site")}
            </div>

            {/* From Date */}
            <div className="flex-1 min-w-[160px]">
              <InputText
                id="fromDate"
                name="fromDate"
                value={fromDate}
                onChange={handleDateChange}
                type="date"
                placeholder="From Date"
                className="w-full border-round-3xl"
                readOnly={loading}
              />
            </div>

            {/* To Date */}
            <div className="flex-1 min-w-[160px]">
              <InputText
                id="toDate"
                name="toDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                type="date"
                placeholder="To Date"
                className="w-full border-round-3xl"
                readOnly={loading}
              />
            </div>
            <div className="flex-1 min-w-[200px]">
              <Dropdown
                value={selectedPaymentType}
                onChange={(e) => setSelectedPaymentType(e.value)}
                options={paymentOptions}
                placeholder="Select Payment Type"
                className="w-full TextArea__Round border-round-3xl"
                showClear
              />
            </div>

            {/* Search Button - Align right */}
            <div
              className="flex justify-content-end align-items-center"
              style={{ flexGrow: 1 }}
            >
              <Button
                label="Search"
                icon="pi pi-search"
                className="p-button-rounded p-button-info ml-auto"
                onClick={() => {
                  setInitialized(true);
                  getSateRevenueData();
                }}
                disabled={loading}
              />
            </div>
          </div>
        )}
      </div>

      <div
        className="p-fluid formgrid grid"
        // style={{
        //   background:
        //     "radial-gradient(at center top, rgba(59, 130, 246, 0.26) 0%, rgba(255, 255, 255, 1) 70%)",
        // }}
      >
        <div className="field col-12 md:col-12">
          {/* Summary Cards */}
          <StatsCards
            stats={statsData}
            site={formik.values.site}
            fromDate={fromDate}
            toDate={toDate}
          />
        </div>

        {/* Vehicle Type Line Chart + Status Donut */}
        <div className="field col-12 md:col-8">
          <div className="dashboard-panel h-full">
            <VehicleTypeChart  />
          </div>
        </div>

        <div className="field col-12 md:col-4">
          <div className="dashboard-panel h-full">
            <h5 className="text-lg font-semibold mb-3">Vehicle status</h5>
            <div className="w-full flex justify-content-center">
              <div style={{ width: "min(100%, 350px)" }}>
                <VehicleStatusChart stats={statsData} {...getPaymentFlags()} />
              </div>
            </div>
          </div>
        </div>

        {/* Parking Stats Donut + Site Stats Bar */}
        <div className="field col-12 md:col-4">



          <div className="dashboard-panel">
            <h5 className="text-lg font-semibold mb-3">Parking status</h5>
            <ParkingStatsChart stats={statsData} {...getPaymentFlags()}/>
          </div>
        </div>

        <div className="field col-12 md:col-8">
          <div className="dashboard-panel h-full">
            <ParkingCollectionChart
              siteId={siteId}
              fromDate={fromDate}
              toDate={toDate}
              {...getPaymentFlags()}
            />
          </div>
        </div>

        <div className="field col-12 md:col-8">
          <div className="dashboard-panel h-full">
            <SiteStatsChart />
          </div>
        </div>
        <div className="field col-12 md:col-4">
          <div className="dashboard-panel h-full">
            <h5 className="text-lg font-semibold mb-3">Revenue comparison</h5>
            <RevenueComparisonChart revenue={revenue} {...getPaymentFlags()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboardd;
